import ButtonDKN from "../../Button/ButtonDKN";

import stv from "../../../assets/images/HomePackage/stv.svg";

import Back3 from "../../../assets/images/HomePackage/Back3.webp";
import tic_white from "../../../assets/images/HomePackage/tic_white.svg";

export default function HomePackage() {
  return (
    <div className="w-full bg-[#F6F7FC]">
      <div className="w-full container mx-auto py-[50px] px-[20px] flex flex-col gap-4 md:gap-8 ">
        <div className="w-full">
          <p className="text-[26px] md:text-[32px] text-[#053CC8] font-semibold text-center ">
            LỰA CHỌN PHÙ HỢP VỚI QUY MÔ
          </p>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6 items-center">
          <div className="w-full px-[24px] py-[30px] shadow-custom-light3 bg-whiteFull lg:w-full lg:h-[620px] md:h-[770px] border-2 border-solid border-gray-300 rounded-[8px] flex flex-col gap-3 md:gap-8  ">
            <div className=" text-[#053CC8] text-[28px] md:text-[32px] font-semibold">
              Basic
            </div>
            <div className="text-[16px] text-[#3763D3]">Dưới 500 học viên</div>

            <div className="flex flex-col gap-1">
              <p className="text-[16px] text-[#606060] font-normal">Chỉ từ</p>
              <p className="text-[24px] text-[#0430A0] font-semibold md:text-[28px]">
                39.000 VNĐ
              </p>
              <p className="text-[16px] text-[#606060] font-normal">
                /Học viên/Tháng
              </p>
            </div>

            <div className="flex items-center justify-center w-full">
              <ButtonDKN
                txt="Đăng ký ngay"
                cl="hover:bg-pa w-full rounded-[8px] "
              />
            </div>

            <div>
              <div className="flex flex-col gap-3 w-full   text-[#333333] text-[16px] font-normal  ">
                <div className="text-[#032478] text-[16px] font-medium">
                  Bao gồm
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="bb" />
                  <p className="text-[16px] text-[#333333] font-normal">
                    CRM{" "}
                    <spam className="text-[#3763D3] font-bold">TỰ ĐỘNG</spam>{" "}
                    toàn bộ quy trình tiếp thị & tuyển sinh.
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="vf" />
                  <p className="text-[16px] text-[#333333] font-normal">
                    Quản lý học viên
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="mk" />

                  <p className="text-[16px] text-[#333333] font-normal">
                    Quản lý giảng dạy và học tập
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="mk" />

                  <p className="text-[16px] text-[#333333] font-normal">
                    Quản lý vận hành trung tâm
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="w-full px-[24px] py-[30px] relative shadow-custom-light bg-center bg-cover bg-no-repeat object-cover  lg:h-[620px] md:h-[770px] border border-solid border-gray-300  rounded-[8px] flex flex-col gap-3 md:gap-8 "
            style={{
              backgroundImage: `url(${Back3})`,
            }}
          >
            <div
              className="absolute right-0 top-0 rounded-custom3 bg-[#FDB62F] px-[8px] py-[4px] text-black text-[16px] font-normal
             ]"
            >
              Recommened
            </div>

            <div className=" text-white text-[28px] md:text-[32px] font-semibold">
              Premium
            </div>
            <div className="text-[16px] text-white">500-1000 học viên</div>

            <div className="flex flex-col gap-1">
              <p className="text-[16px] text-white font-normal">Chỉ từ</p>
              <p className="text-[24px] text-white font-semibold md:text-[28px]">
                50.000 VNĐ
              </p>
              <p className="text-[16px] text-white font-normal">
                / Học viên / Tháng
              </p>
            </div>
            <div className="flex items-center justify-center">
              <ButtonDKN
                txt="Đăng ký ngay"
                cl=" rounded-[8px] bg-white !text-[#053CC8] text-[14px] hover:bg-[#F4F4F4] font-semibold"
              />
            </div>

            <div>
              <div className="flex flex-col gap-3 w-full  text-[#333333] text-[16px] font-normal  ">
                <div className="text-white text-[16px] font-medium">
                  Bao gồm toàn bộ tính năng gói BASIC
                </div>
                <div className="w-full flex items-center gap-2 text-white ">
                  <img src={tic_white} alt="ti" className="text-white" />
                  <p className="text-[16px] text-white font-normal">
                    Web App: ERP Quản trị doanh nghiệp
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 text-white ">
                  <img src={tic_white} alt="mn" />
                  <p className="text-[16px] text-white font-normal">
                    Web App : Education Hỗ trợ giảng dạy và học tập cho giáo
                    viên và học viên.
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 text-white ">
                  <img src={tic_white} alt="po" />

                  <p className="text-[16px] text-white font-normal">
                    Mobile App: Công cụ đa năng dành cho phụ huynh và học viên.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full px-[24px] py-[30px] md:h-[770px] shadow-custom-light3 bg-whiteFull lg:h-[620px] border-2 border-solid border-gray-300  rounded-[8px] flex flex-col gap-3 md:gap-8 ">
            <div className=" text-[#053CC8] text-[28px] md:text-[32px] font-semibold">
              Unlimited
            </div>
            <div className="text-[16px] text-[#3763D3]">Trên 1000 học viên</div>

            <div className="flex flex-col gap-1">
              <p className="text-[16px] text-[#606060] font-normal">Chỉ từ</p>
              <p className="text-[24px] text-[#0430A0] font-semibold md:text-[26px] lg:text-[28px]">
                80.000 VNĐ
              </p>
              <p className="text-[16px] text-[#606060] font-normal">
                / Học viên / Tháng
              </p>
            </div>
            <div className="flex items-center justify-center">
              <ButtonDKN txt="Đăng ký ngay" cl="hover:bg-pa rounded-[8px] " />
            </div>

            <div>
              <div className="flex flex-col gap-3 w-full   text-[#333333] text-[16px] font-normal  ">
                <div className="text-[#032478] text-[16px] font-medium">
                  Bao gồm toàn bộ công cụ của gói BASIC & Premium
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="bb" />
                  <p className="text-[16px] text-[#333333] font-normal">
                    <spam className="text-[#0a0a0a] font-medium">PC App</spam>:
                    Phần mềm học tập trực tuyến E-Learning, mô phỏng 90% lớp học
                    trực tiếp.
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="yh" />
                  <p className="text-[16px] text-[#333333] font-normal">
                    Miễn phí số hóa toàn bộ tài liệu
                  </p>
                </div>
                <div className="w-full flex items-center gap-2 ">
                  <img src={stv} alt="ml" />

                  <p className="text-[16px] text-[#333333] font-normal">
                    Miễn phí tư vấn vận hành, training nhân sự
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
